import {
  getRetailer,
  getRetailerActiveMemberships,
  getRetailerTaxableCountry,
} from "@faire/help-center-utils/serialized-data/getRetailer";
import { THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES } from "@faire/web--source/common/consts/THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";

export const isAusRetailer = () =>
  getRetailerTaxableCountry() === ISO3166Alpha3.AUS;

export const isCanRetailer = () =>
  getRetailerTaxableCountry() === ISO3166Alpha3.CAN;

export const isEurRetailer = () => {
  const retailerCountry = getRetailerTaxableCountry();

  return THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES.map(String).includes(
    retailerCountry ?? ""
  );
};

export const isActiveInsider = () => {
  const retailer = getRetailer();
  const retailerActiveMemberships = getRetailerActiveMemberships();

  return (
    retailer?.insider_membership_state ===
      IRetailer.InsiderMembershipState.ACTIVE || !!retailerActiveMemberships
  );
};
